import { useTranslation } from 'react-i18next';

/**
 * What a lazily loaded screen shows while its chunk downloads: a polite status inside the layout (the
 * rail and the top bar stay), on the same muted ink the table loading row uses.
 */
export function RouteFallback() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex min-h-48 items-center justify-center text-base text-ink-muted"
    >
      {t('common.loading')}
    </div>
  );
}
